<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">
    <img src="./assets/arrow_logo.png" class="arrow" (click)="listPage()" />&nbsp;&nbsp;Add Harvest Crop
  </div>
  <div class="example-header">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="addHarvestForm" (ngSubmit)="onSubmit()">
          <div class="fulllwidth">
            <mat-form-field>
              <input matInput readonly [value]="currentD" />
            </mat-form-field>
            <div>
              <span>
                <mat-form-field style="width: 75%">
                  <mat-select placeholder="Crop" formControlName="cropId">
                    <mat-option *ngFor="let opt of cropDataList" [value]="opt.cropId">
                      {{ opt.cropName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>&nbsp;&nbsp;

                <button type="button" class="add_button_new" mat-raised-button color="primary" (click)="manageCrop()">
                  Manage Crop</button>&nbsp;
              </span>
            </div>
            <div>
              <span>
                <mat-form-field style="width: 75%">
                  <mat-select placeholder="Unit" required formControlName="unitID">
                    <mat-option *ngFor="let opt of unitDataList" [value]="opt.unitID">
                      {{ opt.unitName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>&nbsp;&nbsp;

                <button type="button" class="add_button_new" mat-raised-button color="primary" (click)="manageUnit()">
                  Manage Unit</button>&nbsp;
              </span>
            </div>
            <div class="row">
              <div class="col-sm-9">
                <span>
                  <div class="file-upload-header">Thumbnail image</div>
                  <input type="file" accept="image/png, image/gif, image/jpeg" name="image" class="file-input" (change)="newsFileSelected($event)" #fileUpload />
                  <button type="button" class="file-upload" (click)="fileUpload.click()">
                    <mat-icon>cloud_upload</mat-icon>
                  </button>
                </span>
                &nbsp;&nbsp;
              </div>
              <div class="col-sm-3">
                <img [src]="imageSrc" class="imagePreview" alt="" accept="image/*" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <button mat-button type="submit" [disable]="disable" class="submitBtn pull-right"
                  style="margin-top: 10px">
                  Post
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>